module.exports = __webpack_public_path__ + "static/media/menu-pending-transactions.76c39255.svg";